// Mappe un nom d'icone (string venant du backend) vers le composant lucide-react.
import {
  Users, Baby, Hammer, Landmark, Briefcase, Building2, MapPin, Mountain,
  Cpu, Scale, BookOpen, Gavel, KeyRound, FileText, ShieldCheck, Banknote,
  Leaf, HeartPulse, GraduationCap, Globe, Car, Home, Handshake,
} from 'lucide-react';

const ICONS = {
  Users, Baby, Hammer, Landmark, Briefcase, Building2, MapPin, Mountain,
  Cpu, Scale, BookOpen, Gavel, KeyRound, FileText, ShieldCheck, Banknote,
  Leaf, HeartPulse, GraduationCap, Globe, Car, Home, Handshake,
};

// Retourne le composant icone correspondant, avec repli sur BookOpen.
// Tolerant a la casse (ex: "gavel", "Gavel", "GAVEL").
export const getIcon = (name) => {
  if (!name) return BookOpen;
  if (ICONS[name]) return ICONS[name];
  const key = Object.keys(ICONS).find((k) => k.toLowerCase() === String(name).toLowerCase());
  return key ? ICONS[key] : BookOpen;
};

export default ICONS;
